// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 3524 ? "app" : chunkId) + "." + {"3524":"15a8fc75b7bfb5b65c74","4120":"10ce2bdb4c854c95a31d"}[chunkId] + ".css";
};